import DisplayMessage from "./DisplayMessage";
import ScrollMessage from "./ScrollMessage";
import RotateDevice from "./RotateDevice";
// import LoadingScreen from "./LoadingScreen";

//assets for loading
import cover_food from "../../../public/assets/img/menu_select_food.jpg";
import cover_feed from "../../../public/assets/img/menu_select_feed.jpg";
import cover_fuel from "../../../public/assets/img/menu_select_fuel.jpg";
import cloudsSVG from "../../../public/assets/svg/clouds_menu_select.svg";
import beanSVG from "../../../public/assets/svg/bean.svg";
import cloudsIntroSVG from "../../../public/assets/svg/clouds_journey_intro.svg";
import greenCloudsSvg from "../../../public/assets/svg/clouds_processing.svg";

//these are messages or things we want to persist accross all 4 pages of the site
//put in this one component rather than on each page

export default function SiteWideOverlays() {
  return (
    <div className="">
      {/* turn on for persistant rotate device to portrait on mobile */}
      <RotateDevice />

      {/* turn on for any site under construction sections */}
      {/* if turning this back on, will need to update desired aspect ratios or pages */}
      {/* <DisplayMessage /> */}

      {/* turn on for persistant "scroll to continue" at the bottom of all screens */}
      {/* <ScrollMessage /> */}

      {/* turn on for loading screen*/}
      {/* if turning this back on, will need to update assets */}
      {/* <LoadingScreen assets={[
        cover_food,
        cover_feed,
        cover_fuel,
        cloudsSVG,
        beanSVG,
        cloudsIntroSVG,
        greenCloudsSvg,
        '/assets/img/feed/feed_panel_01.jpg',
        '/assets/img/feed/feed_panel_02.jpg',
        '/assets/img/feed/feed_panel_03.jpg',
        '/assets/img/feed/feed_panel_04.jpg',
        '/assets/img/feed/feed_panel_05.gif',
        '/assets/img/feed/feed_overview_01.jpg',
        '/assets/img/feed/feed_overview_02.jpg',
        '/assets/img/feed/feed_overview_03.jpg',
        '/assets/img/feed/feed_overlay_01.jpg',
        '/assets/img/feed/feed_overlay_03.jpg',
        '/assets/img/feed/feed_overlay_04.jpg',
        '/assets/img/food/food_panel_02.jpg',
        '/assets/img/food/food_overview_03.jpg',
        '/assets/img/food/food_overview_02.jpg',
        '/assets/img/food/food_overview_01.jpg',
        '/assets/img/food/food_overlay_04.jpg',
        '/assets/img/food/food_overlay_03.jpg',
        '/assets/img/food/food_overlay_01.jpg',
        '/assets/img/fuel/heating.png',
        '/assets/img/fuel/fuel_panel_01.jpg',
        '/assets/img/fuel/fuel_panel_02.jpg',
        '/assets/img/fuel/fuel_overview_01.jpg',
        '/assets/img/fuel/fuel_overview_03.jpg',
        '/assets/img/fuel/fuel_overlay_03.jpg',
        '/assets/img/fuel/fuel_overlay_04.jpg',
        '/assets/img/fuel/fuel_overlay_05.jpg',
        '/assets/img/fuel/Animal%20Agriculture-7200%201.png',
        '/assets/img/fuel/fuel_overlay_01.webm',
        '/assets/img/fuel/fuel_overlay_02.webm',
        '/assets/img/fuel/fuel_panel_04.webm',
      ]} /> */}
    </div>
  );
}
